import { DEFAULT_ATTACHMENT_ID } from '../constants';
export function addAttachmentsReducer(state, action) {
    let newState = Object.assign({}, state);
    action.payload.attachments.forEach(attachment => {
        if (attachment.id !== DEFAULT_ATTACHMENT_ID) {
            newState = Object.assign(Object.assign({}, newState), { [attachment.id]: attachment });
        }
    });
    return newState;
}
//# sourceMappingURL=addAttachmentsReducer.js.map